import React from "react";
import {
  createArea,
  updateArea,
  getAreaDetail,
} from "../../helpers/backend_helper";
import CodeDetail from "../Standards/CodeDetail";

const AreaDetail = (props) => (
  <CodeDetail
    {...props}
    codeLabel="Checklist Area"
    getCodeDetail={getAreaDetail}
    createCode={createArea}
    updateCode={updateArea}
  />
);

export default AreaDetail;
